// Version for use in the <Filter /> component
import {addDays, parse as parseDate} from 'date-fns';
import {FilterValue} from '../../../shared/CommonInterfaces';

export interface InputFilters {
  [index: string]: any; // TODO (future) this shouldn't be any
}
// Version to use for querying OMS
export interface ApiFilters {
  [index: string]: any;
}
export interface FilterInfo {
  inputFilters: InputFilters;
  apiFilters: ApiFilters;
}
export const initialFilters: FilterInfo = {
  inputFilters: {},
  apiFilters: {}
};

export const getInputFilterValue = (inputFilters: InputFilters, key: string): string => {
  if (!inputFilters || !inputFilters[key]) {
    return null;
  }

  if (key === 'hasErrors') {
    return inputFilters[key] === true ? 'true' : 'false';
  }

  return inputFilters[key];
};

export const extractNewFilters = (filters: FilterValue[]): FilterInfo => {
  const resultingInputFilters: InputFilters = {};
  const resultingApiFilters: ApiFilters = {};

  filters.forEach((filterValue) => {
    const filter = filterValue.filter;
    const key = filter.key;
    const value = filterValue.value;

    if (key === 'hasErrors') {
      resultingInputFilters[key] = value === 'true';
      resultingApiFilters[key] = value;
    } else if (filter.allowMultiple) {
      let apiValue = value;
      const isLabel = key === 'labels';
      if (isLabel) {
        // We enforce this in the API repo, so we should display what we searched for
        value.labelKey = `${value.labelKey}`.trim().toLowerCase();
        apiValue = `${value.labelKey},${value.labelValue}`;
      }

      if (resultingInputFilters[key]) {
        const idx = resultingInputFilters[key].findIndex((element) => {
          if (isLabel) {
            return element.labelKey === value.labelKey;
          } else {
            return element === apiValue;
          }
        });
        if (idx < 0) {
          resultingApiFilters[key].push(apiValue);
          resultingInputFilters[key].push(value);
        } else if (isLabel) {
          // Label searches use AND logic, so it only makes sense to take the last value
          //  (other multi values are simple objects that won't change)
          resultingApiFilters[key][idx] = apiValue;
          resultingInputFilters[key][idx] = value;
        }
      } else {
        resultingApiFilters[key] = [apiValue];
        resultingInputFilters[key] = [value];
      }
    } else if (['createdAt', 'shipAfter', 'shipBefore', 'closedAt'].includes(key)) {
      const parsedDate = parseDate(value as string);
      // Start
      let exactKey = `${key}From`;
      resultingInputFilters[exactKey] = parsedDate.toLocaleDateString();
      resultingApiFilters[exactKey] = parsedDate.toISOString();

      // End
      exactKey = `${key}To`;
      resultingInputFilters[exactKey] = parsedDate.toLocaleDateString();
      // See note below about inclusivity
      resultingApiFilters[exactKey] = addDays(parsedDate, 1).toISOString();
    } else if (['createdAt', 'shipAfter', 'shipBefore', 'closedAt', 'updatedAt'].some((f) => !!key.match(f))) {
      const parsedDate = parseDate(value as string);
      // Inclusive start, exclusive end so offset by 1 day
      const filterDate = ['createdAtTo', 'shipAfterTo', 'shipBeforeTo', 'closedAtTo', 'updatedAtTo'].includes(key)
        ? addDays(parsedDate, 1)
        : parsedDate;
      // Note we display the input date to be consistent
      resultingInputFilters[key] = parsedDate.toLocaleDateString();
      resultingApiFilters[key] = filterDate.toISOString();
    } else {
      resultingInputFilters[key] = value;
      resultingApiFilters[key] = value;
    }
  });

  return {apiFilters: resultingApiFilters, inputFilters: resultingInputFilters};
};
